
define('unknown/models/loginModel',[
	'jquery',
	'underscore',
	'backbone'
], function($, _, Backbone){
	var Login = Backbone.Model.extend({
		urlRoot:"/draftapp/auth/login",
		defaults: {
			userName: null,
			password: null
	    },

	    initialize: function() {
	    	
	    },
	});
	
	
	return Login;  
});